export const PRODUCT_MODAL_TYPE = 'Product';
export const ALIAS_MODAL_TYPE = 'Alias';

export const CHOOSE_IMPORT_DIALOGUE = 'CHOOSE_IMPORT_DIALOGUE';
export const IMPORT_IN_PROGRESS_DIALOGUE = 'IMPORT_IN_PROGRESS_DIALOGUE';

export const IDENTIFY_BY_SKU = 'sku';
export const IDENTIFY_BY_NAME = 'name';
